import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Outstanding Overseas Executive component for eligibility tab
 */
const OutstandingOverseasExecutive = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="outstanding-overseas-executive-component"
    >
      <AccordionV2
        testId="outstanding-overseas-executive-of-the-year"
        className="border-none py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Outstanding Overseas Executive of the Year" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 px-6 py-4">
          <p>
            No restrictions on age, sex or race but the candidate must be a
            Singaporean who works and lives overseas.
            <br />
            He/she must be involved in a business enterprise either running
            his/her own local company or head of the Singapore
            division/subsidiary of a large organisation.
          </p>

          <p>
            He/she must be involved in a business enterprise either running
            his/her own local company or head of any Singapore or foreign
            division/subsidiary of a large organisation.
          </p>

          <p>
            <strong>Managerial Skills</strong>
          </p>

          <p>He/she must show the abilities to:</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Adapt to the changing business environment and standards</li>
            <li>
              Contribute to the upgrading of managerial skills and the
              establishment of a viable organisation structure
            </li>
            <li>Persevere in working towards objectives</li>
            <li>
              Innovate and be outward looking in his/her approach to business
            </li>
            <li>Win respect of subordinates</li>
            <li>
              Set an example for the organisation and motivate its employees
            </li>
          </ul>

          <p>
            <strong>Financial Performance</strong>
          </p>

          <p>He/she must have:</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Made an outstanding and sustained contribution to the financial
              viability of the company
            </li>
            <li>
              Contributed to an improvement on return on capital invested in the
              company, subsidiary or division
            </li>
            <li>Exercise prudent management of funds or financial assets</li>
          </ul>

          <p>
            <strong>Contribution to the Community</strong>
          </p>

          <p>
            He/she must have made positive contribution to Singapore and the
            international community.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default OutstandingOverseasExecutive;
